"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eq = eq;
function eq(a, b, options) {
  return (a === b ? options.fn : options.inverse)(this);
}